import React from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Pagination from "@material-ui/lab/Pagination/Pagination";
import Select from "../../Select";

export const DataGridFooter = ({
  data,
  handleChangePerPage,
  perPage,
  page,
  hideSelect,
  handleChangePage,
  paginationOptions = [],
}) => {
  // Inline styles for the DataGridFooter
  const footerStyle = {
    padding: "3rem 0 0",
    display: "flex",
    alignItems: "center",
    borderTop: "1px solid #ecf0f3",
    justifyContent: "space-between",
  };

  const selectWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const paginationStyle = {
    color: "rgba(0, 0, 0, 0.6)",
    padding: "0.5rem",
    fontSize: "14px",
  };

  return (
    <div style={footerStyle}>
      {Math.ceil(data.length / perPage) > 1 ? (
        <Pagination
          count={Math.ceil(data.length / perPage)}
          page={page}
          showFirstButton
          showLastButton
          classes={{ root: "text-primary" }}
          shape="rounded"
          onChange={handleChangePage}
        />
      ) : (
        <div />
      )}

      {hideSelect ? null : (
        <div style={selectWrapperStyle}>
          <div style={paginationStyle}>Rows per page: </div>

          <div>
            <Select
              value={perPage}
              background="none"
              options={paginationOptions.map((option) => ({
                value: option,
                label: option,
              }))}
              IconComponent={ExpandMoreIcon}
              onChange={handleChangePerPage}
            />
          </div>

          <div style={paginationStyle}>
            {(page - 1) * perPage + 1}-
            {data.length > perPage ? page * perPage : data.length} of{" "}
            {data.length}
          </div>
        </div>
      )}
    </div>
  );
};
